/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, Card, Row, Col, Upload, Select,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import useCreateBusinessType from './useCreateBusinessType';
import styles from './CreateBusinessType.module.less';

const progressBarUpload = {
  strokeColor: {
    '0%': '#108ee9',
    '100%': '#87d068',
  },
  strokeWidth: 3,
  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
};
const iconProps = {
  className: 'anticon',
  style: { fontSize: 21, minWidth: 'auto' },
};
const { Dragger } = Upload;

function CreateBusinessType({ ...props }) {

  const { t } = useTranslation();
  const {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditBusinessType,
    changeFile,
    fileRequest,
    loadingForm,
    form,
    clearType
  } = useCreateBusinessType();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>

        <Form
          form={form}
          name="CreateBusinessType"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          layout="vertical"
          initialValues={{
            ...dataForm, remenber: true,
          }}
          values={{ name: '', description: '', logo_file: '' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >

          <Card style={{ width: '100%', marginBottom: '1rem' }}>
            <Row>
              <Col xs={{span: 24 }} sm={{span: 24 }} md={{span: 20 }} lg={{span: 20 }} xl={{span: 20 }}
                className="miga_title"
              >
                <span style={{color:'#39587d'}}>{idToEdit ? t('common.edit_bussiness') : t('common.create_bussiness')}</span>
                <Breadcrumb className={styles.date_wrapper}>
                  <Breadcrumb.Item className={styles.breadcrumb}>
                    <Link to="/dispositivos/negocio">{t('menu_items.main.business_type')}</Link>
                  </Breadcrumb.Item>
                  {(idToEdit)
                    ? (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.business_type_edit')}</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.breadcrumb}>{dataForm && dataForm.name}</Breadcrumb.Item>
                      </>
                    )
                    : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_business_type.new_business_type')}</Breadcrumb.Item>}
                </Breadcrumb>
              </Col> 
              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}
                className={styles.column_btn}
              > 
                 <Button onClick={cancelCreateEditBusinessType}>X</Button>

                <Button key="button"  className='m_l' type="primary" loading={loadingForm} htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
                 {(!idToEdit) ? t('views.create_business_type.buttons.create') : t('views.create_business_type.buttons.update') }
                </Button> 

              </Col>
            </Row>
          </Card>

          <Card>
            <Row>
              <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.name')}
                  name="name"
                  rules={[
                    { required: true, message: t('views.create_business_type.form.name_message') },
                  ]}
                >
                  <Input className={styles.input} placeholder={t('views.create_business_type.form.name_place_holder')} />
                </Form.Item>
              </Col> 

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.type')}
                  name="type"
                  rules={[
                    { required: true, message: t('views.create_business_type.form.type_message') },
                  ]}
                >
                  <Select 
                    style={{ width: '100%' }}
                    placeholder={t('views.create_business_type.form.type_place_holder')}
                    disabled={idToEdit}
                    onChange={(value) => clearType(value)} 
                    options={[
                          { value: 'Retail', label: 'Retail' },
                          { value: 'Comunidades', label: 'Comunidades' }, 
                      ]}
                  /> 
                </Form.Item>
              </Col>
              
              <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.latitude')}
                  name="latitude" 
                >
                  <Input className={styles.input} placeholder={t('views.create_business_type.form.latitude_place_holder')} />
                </Form.Item>
              </Col>
                
              <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.longitude')}
                  name="longitude" 
                >
                  <Input className={styles.input} placeholder={t('views.create_business_type.form.longitude_place_holder')} />
                </Form.Item>
              </Col> 
              
              <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.description')}
                  name="description"
                  rules={[{ required: true, message: t('views.create_business_type.form.description_message') }]}
                >
                  <Input.TextArea className={styles.input} rows={3} placeholder={t('views.create_business_type.form.description_place_holder')} />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                <Form.Item
                  className={styles.label}
                  label={t('views.create_business_type.form.logo_file')}
                  name="logo_file"
                  rules={[{ required: !dataForm.id, message: t('views.create_business_type.form.logo_file_message') }]}
                >
                  <Dragger
                    rules={[{ required: true, message: t('views.create_business_type.form.logo_file_place_holder') }]}
                    beforeUpload={() => true}
                    customRequest={fileRequest}
                    onChange={changeFile}
                    multiple={false}
                    maxCount={1}
                    progress={progressBarUpload}
                  >
                    <FontAwesomeIcon icon={faUpload} {...iconProps} />
                    <p className="ant-upload-text">{t('common.click_or_drag')}</p>
                    <p className="ant-upload-hint">
                      {t('views.create_business_type.form.logo_file_place_holder')}
                    </p>
                  </Dragger>
                </Form.Item>
              </Col>

              {
              dataForm?.type && dataForm?.type === 'Comunidades' &&
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_business_type.form.type_communities')}
                    name="type_communitie"
                    rules={[
                      { required: true, message: t('views.create_business_type.form.type_communities_message') },
                    ]}
                  >
                    <Select 
                      style={{ width: '100%' }}
                      placeholder={t('views.create_business_type.form.type_communities_place_holder')}
                      options={[
                            { value: 'Escalar', label: 'Escalar' },
                            { value: 'AmiCeslsia', label: 'Ami Ceslsia' }, 
                            { value: 'AmiIoT', label: 'Ami IoT' }, 
                        ]}
                    /> 
                  </Form.Item>
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_business_type.form.settlement_cycle')}
                    name="settlement_cycle"
                    rules={[
                      { required: true, message: t('views.create_business_type.form.settlement_cycle_message') },
                    ]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_business_type.form.settlement_cycle_place_holder')} />
                  </Form.Item>
                </Col> 

                <Col xs={{ span: 24 }} sm={{ span: 24, }} md={{ span: 12, }} lg={{ span: 12, }} xl={{ span: 12 }} >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_business_type.form.frt')}
                    name="frt"
                    rules={[
                      { required: true, message: t('views.create_business_type.form.frt_message') },
                    ]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_business_type.form.frt_place_holder')} />
                  </Form.Item>
                </Col> 

              </> 
              }

            </Row>
          </Card>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateBusinessType);
